
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7069/api/',
    //Live
    apiUrl: 'https://mga-api.off-ease.com/api/',
    //Demo
    //apiUrl: 'https://cr-api.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

